<template>
  <section id="smart-dom" class="smart-home section">
    <div class="container">
      <div class="section-header" data-aos="fade-up">
        <h2>Smart Dom</h2>
        <div class="section-line"></div>
        <p>Nowoczesne rozwiązania dla inteligentnego domu</p>
      </div>
      
      <div class="smart-content">
        <div class="feature-cards">
          <div class="feature-card" data-aos="fade-right" data-aos-delay="100">
            <div class="feature-icon">🏠</div>
            <h3>Automatyka Domowa</h3>
            <p>Instalujemy i obsługujemy automatykę domową w oparciu o gotowe rozwiązania jak i dostosowujemy do indywidualnych potrzeb klienta.</p>
          </div>
          
          <div class="feature-card" data-aos="fade-right" data-aos-delay="200">
            <div class="feature-icon">💧</div>
            <h3>Uzdatnianie Wody</h3>
            <p>Proponujemy systemy uzdatniania wody do użytku własnego jak i zapobiegamy osadzaniu się kamienia co może prowadzić do uszkodzenia sprzętu AGD jak również do obniżenia sprawności grzewczej.</p>
          </div>
        </div>    
      
        
        <div class="smart-image" data-aos="fade-left">
          <div class="image-placeholder">
            <div class="placeholder-content">
              <h3>🏡 Smart Home</h3>
              <p>Inteligentne rozwiązania<br>dla Twojego domu</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SmartHomeSection'
}
</script>

<style lang="scss" scoped>
.smart-home {
  background: #f8f9fa;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    margin: 0 auto 20px;
    border-radius: 2px;
  }
  
  p {
    font-size: 1.1rem;
    color: #666;
  }
}

.smart-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.feature-cards {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.feature-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  .feature-icon {
    font-size: 2.5rem;
    margin-bottom: 15px;
  }
  
  h3 {
    font-size: 1.3rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  p {
    color: #666;
    line-height: 1.6;
  }
}

.smart-image {
  .image-placeholder {
    width: 100%;
    height: 500px;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    border-radius: 15px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
    
    .placeholder-content {
      h3 {
        font-size: 3rem;
        margin-bottom: 20px;
        color: white;
      }
      
      p {
        font-size: 1.2rem;
        opacity: 0.9;
        color: white;
      }
    }
  }
}

@media (max-width: 768px) {
  .smart-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .feature-cards {
    gap: 20px;
  }
  
  .smart-image .image-placeholder {
    height: 300px;
    
    .placeholder-content h3 {
      font-size: 2rem;
    }
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
}
</style>